import { Ride } from '../../apiTypes';

export const name = 'ridesSoon';

export const types = {
    SET_RIDES_SOON: `${name}/SET_RIDES_SOON`,
};

export interface CurrentGroupState {
    ridesSoon: Ride[];
}

// InitialState
const initialState: CurrentGroupState = {
    ridesSoon: null,
};

const reducer = (state = initialState, action: any = {}): any => {
    switch (action.type) {
        case types.SET_RIDES_SOON:
            return {
                ...state,
                ridesSoon: action.payload.rides,
            };
        default:
            return state;
    }
};
export default reducer;

// ActionCreators
export const actions = {
    setRidesSoon: (rides: Ride[]): any => ({ type: types.SET_RIDES_SOON, payload: { rides } }),
};

const localState = (state: any): CurrentGroupState => state[name] || initialState;
export const selectors = {
    ridesSoon: (state): Ride[] => localState(state).ridesSoon,
};
